import React from 'react';
import { Card } from '@hopper/card';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';

var _excluded$4 = ["styles"];
function _extends$4() {
  _extends$4 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$4.apply(this, arguments);
}
var SuccessIcon = (function (_ref) {
  _ref.styles;
    var props = _objectWithoutProperties(_ref, _excluded$4);
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    width: "24",
    height: "24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 6.5l-11 11-5-5",
    stroke: "#36B37E",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
});

var _excluded$3 = ["styles"];
function _extends$3() {
  _extends$3 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$3.apply(this, arguments);
}
var WarningIcon = (function (_ref) {
  _ref.styles;
    var props = _objectWithoutProperties(_ref, _excluded$3);
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    width: "24",
    height: "24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 21.5c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zM12 7.5v4M12 15.5h.01",
    stroke: "#FFBC02",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
});

var _excluded$2 = ["styles"];
function _extends$2() {
  _extends$2 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}
var DangerIcon = (function (_ref) {
  _ref.styles;
    var props = _objectWithoutProperties(_ref, _excluded$2);
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    width: "24",
    height: "24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18 6.398l-12 12M6 6.398l12 12",
    stroke: "#CB3939",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
});

var _excluded$1 = ["styles"];
function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
var InfoIcon = (function (_ref) {
  _ref.styles;
    var props = _objectWithoutProperties(_ref, _excluded$1);
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    width: "24",
    height: "24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM12 16v-4M12 8h.01",
    stroke: "#5263F1",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
});

var _excluded = ["styles"];
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var CloseIcon = (function (_ref) {
  _ref.styles;
    var props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 1.266l-8 8M1 1.266l8 8",
    stroke: "#95999A",
    strokeWidth: "1.333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
});

var VARIANT_ICONS_MAPPING = {
  success: /*#__PURE__*/React.createElement(SuccessIcon, null),
  warning: /*#__PURE__*/React.createElement(WarningIcon, null),
  danger: /*#__PURE__*/React.createElement(DangerIcon, null),
  info: /*#__PURE__*/React.createElement(InfoIcon, null)
};
var DEFAULT_VARIANT = "success";
var Notification = function Notification(_a) {
  var title = _a.title,
    _b = _a.variant,
    variant = _b === void 0 ? DEFAULT_VARIANT : _b,
    _c = _a.subtitle,
    subtitle = _c === void 0 ? "" : _c,
    icon = _a.icon,
    actions = _a.actions,
    onClose = _a.onClose;
  var notificationIcon = icon || VARIANT_ICONS_MAPPING[variant || DEFAULT_VARIANT];
  return /*#__PURE__*/React.createElement(Card, {
    className: "shadow border border-light"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex p-lg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mr-md leading-150"
  }, notificationIcon), /*#__PURE__*/React.createElement("div", {
    className: "mr-md flex items-center"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "font-bold text-darkest leading-150 tw:text-tw-secondary-800",
    "data-test-role": "notification-title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "flex text-sm mt-xs"
  }, subtitle && /*#__PURE__*/React.createElement("div", {
    className: "mr-xs text-secondary tw:text-tw-secondary-500",
    "data-test-role": "notification-subtitle"
  }, subtitle), actions && /*#__PURE__*/React.createElement("div", {
    className: "underline text-primary tw:text-tw-primary-500",
    "data-test-role": "notification-actions"
  }, actions)))), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 text-right mr-md"
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-right flex cursor-pointer mt-xs",
    "data-test-role": "notification-close-icon"
  }, /*#__PURE__*/React.createElement("span", {
    className: "h-lg flex items-center"
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    style: {
      width: 10,
      height: 10
    },
    onClick: onClose
  })))));
};

export { Notification };
//# sourceMappingURL=index.es.js.map
